import { MutationTree } from "vuex";
import {
  IProfileState,
  IAuthProfile,
  ITwoFactorSetup,
} from "@/core/interfaces/profile.interface";

const mutations: MutationTree<IProfileState> = {
  setProfileFetching(state, payload: boolean) {
    state.isFetchingProfile = payload;
  },
  setProfileUpdateLoading(state, payload: boolean) {
    state.isUpdatingProfile = payload;
  },
  setVerifyAuthenticatorLoading(state, payload: boolean) {
    state.isVerifyingAuthenticator = payload;
  },
  setAuthProfile(state, payload: IAuthProfile | null) {
    state.authProfile = payload;
  },
  setTwoFactorSetup(state, payload: ITwoFactorSetup | null) {
    state.twoFactorSetup = payload;
  },
};

export default mutations;
